module.exports = __webpack_public_path__ + "static/img/logo.2e0e24f5.png";